import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyAu_WrUSjpyWL5XWOeyjmM1fxx5-o3KHSc",
  authDomain: "convertology-b1d5b.firebaseapp.com",
  projectId: "convertology-b1d5b",
  storageBucket: "convertology-b1d5b.firebasestorage.app",
  messagingSenderId: "649137950644",
  appId: "1:649137950644:web:a821109dd3881e91446ce1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const db = getFirestore(app);
export const auth = getAuth(app);

export default app;